export enum AlertType {
    Confirmation = 'Confirmation',
    Information = 'Information',
    Warning = 'Warning'
}